module.exports = __webpack_public_path__ + "img/abecedar-mare-1783-pagina-de-titlu-big.bb8a06dc.png";